(() => {
  const hero = document.querySelector('[data-cv-live-hero]');
  if (!hero || hero.dataset.cvBound) return;
  hero.dataset.cvBound = 'true';
  const duel = hero.querySelector('.cv-live-duel');
  let frame = hero.querySelector('[data-cv-live-frame]');
  const wrap = hero.querySelector('[data-cv-frame-wrap]');
  const home = hero.querySelector('[data-cv-cart-home]');
  const dialog = hero.querySelector('[data-cv-cart-dialog]');
  const dialogHome = hero.querySelector('[data-cv-dialog-home]');
  const expand = hero.querySelector('[data-cv-expand]');
  const resetButtons = [...hero.querySelectorAll('[data-cv-reset]')];
  const loading = hero.querySelector('[data-cv-live-loading]');
  const status = hero.querySelector('[data-cv-live-status]');
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = matchMedia('(min-width:821px)');
  const intro=hero.querySelector('.neural-intro');
  const label=hero.querySelector('.neural-shopify-label');
  const submit=hero.querySelector('[data-cvt-submit-label]') || hero.querySelector('.neural-submit span');
  const note=hero.querySelector('.neural-form-note');
  const input=hero.querySelector('#cv-ask-url');
  const original={intro:intro.innerHTML,label:label.innerHTML,submit:submit.textContent,note:note.innerHTML,describedby:input.getAttribute('aria-describedby'),placeholder:input.placeholder};
  let hasLoaded=false;
  let returnFocus;
  let ready = false;
  let initData;
  let loadVersion = 0;
  let loadTimer;
  const loadingMarkup = loading.innerHTML;
  function resize() {
    const rect = wrap.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    const viewportWidth=dialog.open?Math.round(rect.width):390;
    const scale = rect.width / viewportWidth;
    frame.style.width=`${viewportWidth}px`;
    frame.style.height = `${Math.round(rect.height / scale)}px`;
    frame.style.transform = `scale(${scale})`;
  }
  new ResizeObserver(resize).observe(wrap);
  function openCart() {
    returnFocus = document.activeElement;
    if(initData)initData.mode='drawer';
    dialog.showModal();
    moveFrame(dialogHome);
    resize();
    frame.contentWindow?.postMessage({type:'cv-hero:mode',mode:'drawer'},location.origin);
    frame.focus({preventScroll:true});
    frame.contentWindow?.postMessage({type:'cv-hero:focus',target:'close'},location.origin);
  }
  expand?.addEventListener('click',openCart);
  resetButtons.forEach(button=>button.addEventListener('click',()=>loadFrame(true)));
  hero.querySelector('[data-cv-collapse]')?.addEventListener('click',()=>dialog.close());
  function moveFrame(target){
    if(typeof target.moveBefore==='function') target.moveBefore(wrap,null);
    else {ready=false;loading.hidden=false;target.append(wrap);loadFrame()}
  }
  dialog.addEventListener('close',()=>{if(initData)initData.mode='inline';moveFrame(home);resize();frame.contentWindow?.postMessage({type:'cv-hero:mode',mode:'inline'},location.origin);returnFocus?.focus({preventScroll:true})});
  dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close()}});
  function tryCart(){
    if(matchMedia('(max-width:820px)').matches){duel.scrollIntoView({behavior:reduceMotion.matches?'instant':'smooth',block:'start'})}
    else {frame.focus({preventScroll:true});frame.contentWindow?.postMessage({type:'cv-hero:focus'},location.origin);home.animate?.([{outline:'3px solid #a8e5ce'},{outline:'3px solid transparent'}],{duration:reduceMotion.matches?1:1200})}
  }
  hero.querySelector('[data-cv-try-live]').addEventListener('click',tryCart);
  hero.querySelector('[data-cv-play]').addEventListener('click',tryCart);
  window.addEventListener('message',event=>{
    if(event.source!==frame.contentWindow)return;
    if(event.origin!==location.origin)return;
    if(event.data?.cartState && initData)initData.cartState=event.data.cartState;
    if(event.data?.type==='cv-hero:frame-ready' && initData){frame.contentWindow.postMessage(initData,location.origin)}
    if(event.data?.type==='cv-hero:ready'){
      clearTimeout(loadTimer);
      resetButtons.forEach(button=>button.disabled=false);
      ready=true;loading.hidden=true;status.textContent='Live cart · Try it';duel.dataset.ready='true';
      frame.contentWindow.postMessage({type:'cv-hero:mode',mode:dialog.open?'drawer':'inline'},location.origin);
    }
    if(event.data?.type==='cv-hero:interacted'){duel.dataset.interacted='true'}
    if(event.data?.type==='cv-hero:restart')loadFrame(true);
    if(event.data?.type==='cv-hero:close' && dialog.open)dialog.close();
    if(event.data?.type==='cv-hero:error'){showError()}
  });
  function showError(){
    if(ready)return;
    resetButtons.forEach(button=>button.disabled=false);
    status.textContent='Cart unavailable';
    loading.replaceChildren();
    const label=document.createElement('strong');label.textContent='Let’s try that again.';
    const retry=document.createElement('button');retry.type='button';retry.textContent='Reload live cart';retry.style.cssText='padding:12px 18px;border:0;border-radius:6px;background:#f5a4ce;color:#15243b;cursor:pointer';retry.addEventListener('click',loadFrame);
    loading.append(label,retry);loading.hidden=false;
  }
  async function loadFrame(restarting=false){
    const preservedState=restarting?undefined:initData?.cartState;
    const version=++loadVersion;
    clearTimeout(loadTimer);
    ready=false;initData=undefined;
    delete duel.dataset.ready;delete duel.dataset.interacted;
    resetButtons.forEach(button=>button.disabled=true);
    status.textContent=restarting?'Resetting cart…':'Loading live cart';
    loading.innerHTML=loadingMarkup;loading.hidden=false;
    if(restarting)loading.querySelector('strong').textContent='Starting fresh…';
    // A new browsing context clears renderer state, claimed offers and the
    // frame's isolated storage. Old frame messages fail the source check.
    const freshFrame=frame.cloneNode(false);
    freshFrame.removeAttribute('srcdoc');
    frame.replaceWith(freshFrame);frame=freshFrame;
    try {
      const responses=await Promise.all([frame.dataset.frameSrc,frame.dataset.configSrc,frame.dataset.productsSrc].map(url=>fetch(url)));
      if(responses.some(response=>!response.ok))throw Error('Frame failed');
      let html=await responses[0].text();
      const config=await responses[1].json();
      const products=await responses[2].json();
      if(version!==loadVersion)return;
      const runtime=[...document.scripts].find(script=>/^https:\/\/cdn\.shopify\.com\/extensions\/.+\/assets\/cart-drawer\.js$/.test(script.src));
      initData={type:'cv-hero:init',cartState:preservedState,config,products:products.products,currency:'EUR',mode:dialog.open?'drawer':'inline',runtimeUrl:runtime?.src || 'https://cdn.shopify.com/extensions/01a17e29-904e-7cce-a349-f7e0f253128d/b559e93/assets/cart-drawer.js'};
      html=html.replace('./cartivate-hero-frame.js',new URL(frame.dataset.scriptSrc,location.href).href);
      frame.srcdoc=html;
      resize();
      loadTimer=setTimeout(()=>{if(version===loadVersion&&!ready)showError()},25000);
    }catch{if(version===loadVersion)showError()}
  }
  function adapt(){
    if(desktop.matches){
      hero.querySelectorAll('[data-desktop-src]').forEach(image=>{if(!image.hasAttribute('src'))image.src=image.dataset.desktopSrc});
      intro.innerHTML='That cart on the right? It actually works.<br>Try the rewards. Play with the offers.<br>Then see what it looks like on your store.';
      label.textContent='Preview your Shopify store';
      submit.textContent='Preview my Shopify cart';
      note.innerHTML='Free cart preview <span>·</span> No install needed';
      input.placeholder='your-store.myshopify.com';
      input.setAttribute('aria-describedby','cv-store-url-help '+original.describedby);
      if(!hasLoaded){hasLoaded=true;loadFrame()}
      resize();
    }else{
      if(dialog.open)dialog.close();
      intro.innerHTML=original.intro;label.innerHTML=original.label;submit.textContent=original.submit;note.innerHTML=original.note;
      input.placeholder=original.placeholder;
      input.setAttribute('aria-describedby',original.describedby);
    }
  }
  desktop.addEventListener('change',adapt);
  adapt();
})();

/* Landing-page checkout demo invitation; reacts to renderer mounts. */
(()=>{
try{CSS.registerProperty({name:'--cv-orbit-angle',syntax:'<angle>',inherits:false,initialValue:'0deg'})}catch{}
let observedShadow;
const shadowObserver=new MutationObserver(mount);
function mount(){
const root=document.getElementById('cartivate-root');
const shadow=root&&[...root.querySelectorAll('*')].find(e=>e.shadowRoot)?.shadowRoot;
if(!shadow)return;
if(shadow!==observedShadow){shadowObserver.disconnect();observedShadow=shadow;shadowObserver.observe(shadow,{childList:true,subtree:true})}
if(!shadow.querySelector('#cv-preview-spotlight-style')){
const style=document.createElement('style');style.id='cv-preview-spotlight-style';style.textContent=`
[data-part="cart-checkout"]{position:relative!important;overflow:visible!important;outline:1px solid #e873b4!important;outline-offset:4px!important;margin-top:24px!important;isolation:isolate}
.cv-spotlight-tab{position:absolute;z-index:5;top:-24px;left:50%;transform:translateX(-50%);height:24px;padding:0 12px;display:flex;align-items:center;gap:8px;border:1px solid #15243b;border-radius:7px 7px 0 0;background:#f5a4ce;color:#15243b;font:800 11px/1 Arial,sans-serif;letter-spacing:1.2px;white-space:nowrap;pointer-events:none;box-shadow:0 -2px 8px #15243b12}
.cv-spotlight-tab span{font-size:15px;font-weight:500;line-height:1}

.cv-spotlight-orbit{position:absolute;inset:-6px;z-index:3;border-radius:inherit;padding:2px;pointer-events:none;background:conic-gradient(from var(--cv-orbit-angle),transparent 0deg,transparent 210deg,#e873b4 265deg,#f5a4ce 300deg,#fff9fe 325deg,#a8e5ce 345deg,transparent 360deg);-webkit-mask:linear-gradient(#fff 0 0) content-box,linear-gradient(#fff 0 0);-webkit-mask-composite:xor;mask-composite:exclude;animation:cvOrbit 3s linear infinite}
@keyframes cvOrbit{to{--cv-orbit-angle:360deg}}

@media(prefers-reduced-motion:reduce){.cv-spotlight-orbit{animation:none}}
`;shadow.append(style)}
const button=shadow.querySelector('[data-part="cart-checkout"]');
if(button&&!button.querySelector('.cv-spotlight-tab')){const label=document.createElement('span');label.className='cv-spotlight-tab';label.setAttribute('aria-hidden','true');label.innerHTML='TRY ME <span>↓</span>';button.append(label)}
if(button&&!button.querySelector('.cv-spotlight-orbit')){const orbit=document.createElement('span');orbit.className='cv-spotlight-orbit';orbit.setAttribute('aria-hidden','true');button.append(orbit)}
}
const appRoot=document.getElementById('cartivate-root');
if(appRoot){new MutationObserver(mount).observe(appRoot,{childList:true,subtree:true});mount()}
})();
